/* eslint-disable no-undef */
/* eslint-disable no-new */
const styleDropDowns = () => {
    const campaignSelects = document.querySelectorAll('.custom-multi-select select.field_select_one');
    campaignSelects.forEach( (select) => {
        new TomSelect(select, {
            plugins: ['remove_button'],
            maxItems: 1,
            sortField: {
                field: 'select',
                direction: 'asc',
            },
            onDropdownOpen: function(dropdown) {
                dropdown.parentElement.parentElement.querySelector('label.floating-label').classList.add('active');
            },
            onDropdownClose: function(dropdown) {
                if ( dropdown.querySelectorAll('.selected').length == 0){
                    dropdown.parentElement.parentElement.querySelector('label.floating-label').classList.remove('active');
                }
            },
            onBlur: function(){
                if ( this.wrapper.querySelectorAll('.selected').length == 0){
                    this.wrapper.parentElement.querySelector('label.floating-label').classList.remove('active');
                }
            },
            onChange: function(){
                this.wrapper.classList.toggle('is-invalid', !this.isValid);
            },
        });
        if (select.value != ''){
            select.parentElement.querySelector('label.floating-label').classList.add('active');
        }
    });
    const multiselect = document.querySelectorAll('.custom-multi-select select:not(.field_select_one)');
    multiselect.forEach( (select) => {
        new TomSelect(select, {
            plugins: ['remove_button'],
            onDropdownOpen: function(dropdown) {
                dropdown.parentElement.parentElement.querySelector('label.floating-label').classList.add('active');
            },
            onDropdownClose: function(dropdown) {
                if ( dropdown.parentElement.parentElement.querySelectorAll('.has-items').length == 0){
                    dropdown.parentElement.parentElement.querySelector('label.floating-label').classList.remove('active');
                }
            },
            onClear: function(){
                this.wrapper.parentElement.querySelector('label.floating-label').classList.remove('active');
                this.wrapper.parentElement.querySelector('.mdl-textfield__error.active').classList.remove('active');
            },
            onBlur: function(){
                if ( !this.wrapper.matches('.has-items') ){
                    this.wrapper.parentElement.querySelector('label.floating-label').classList.remove('active');
                }
            },
            onChange: function(){
                this.wrapper.classList.toggle('is-invalid', !this.isValid);
            }
        });
    });
};

export default styleDropDowns;